import { createRoot } from 'react-dom/client';
import { Outlet, Route, BrowserRouter as Router, Routes } from 'react-router';

import { ToastContainer } from 'react-toastify';
import ActivateGoogleCalendar from './components/ActivateGoogleCalendar';
import CustomCalendar from './components/CustomCalendar';
import FinishGoogleCalendarActivation from './components/FinishGoogleCalendarActivation';
import Home from './components/Home';
import Login from './components/Login';
import MyApp from './components/MyApp';
import People from './components/People';
import PeopleEdit from './components/PeopleEdit';
import PeoplePassword from './components/PeoplePassword';

import ProtectedRoute from './components/RouterGuard';

import './app.css';
import CoverPhotos from './components/CoverPhotos';
import CustomReport from './components/CustomReport';
import DayEvents from './components/DayEvents';
import ExpenseEdit from './components/ExpenseEdit';
import Expenses from './components/Expenses';

import GoogleReview from './components/GoogleReview';
import IncomeEdit from './components/IncomeEdit';
import Incomes from './components/Incomes';
import SiteCarousel from './components/SiteCarousel';
import './hack.js';

const _layout = () => {
  return (
    <div className="app-container">
      <ToastContainer></ToastContainer>
      <Outlet></Outlet>
    </div>
  );
};

const _app = () => {
  return (
    <Routes>
      <Route element={<_layout />}>
        <Route path="/" element={<MyApp />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/people"
          element={
            <ProtectedRoute>
              <People />
            </ProtectedRoute>
          }
        />
        <Route
          path="/people/:id/edit"
          element={
            <ProtectedRoute>
              <PeopleEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/people/new"
          element={
            <ProtectedRoute>
              <PeopleEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/people/:id/password"
          element={
            <ProtectedRoute>
              <PeoplePassword />
            </ProtectedRoute>
          }
        />
        <Route
          path="/oauth2"
          element={
            <ProtectedRoute>
              <FinishGoogleCalendarActivation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/google-calendar"
          element={
            <ProtectedRoute>
              <ActivateGoogleCalendar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/calendar"
          element={
            <ProtectedRoute>
              <CustomCalendar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <CustomReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cover-photos"
          element={
            <ProtectedRoute>
              <CoverPhotos />
            </ProtectedRoute>
          }
        />
        <Route
          path="/google-reviews"
          element={
            <ProtectedRoute>
              <GoogleReview />
            </ProtectedRoute>
          }
        />
        <Route
          path="/site-carousel"
          element={
            <ProtectedRoute>
              <SiteCarousel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/expenses"
          element={
            <ProtectedRoute>
              <Expenses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/expenses/:id/edit"
          element={
            <ProtectedRoute>
              <ExpenseEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/expenses/new"
          element={
            <ProtectedRoute>
              <ExpenseEdit />
            </ProtectedRoute>
          }
        />

        <Route
          path="/incomes"
          element={
            <ProtectedRoute>
              <Incomes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/incomes/:id/edit"
          element={
            <ProtectedRoute>
              <IncomeEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/incomes/new"
          element={
            <ProtectedRoute>
              <IncomeEdit />
            </ProtectedRoute>
          }
        />

        <Route
          path="/day-events"
          element={
            <ProtectedRoute>
              <DayEvents />
            </ProtectedRoute>
          }
        />
      </Route>
    </Routes>
  );
};

const root = createRoot(document.getElementById('app-container')!);
root.render(
  <Router basename="/admin">
    <_app />
  </Router>,
);
